const base64ToBlob = (base64, mime) => {
  const byteString = atob(base64.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mime });
};

const setFileInputFromBase64 = (base64Data, fileInput) => {
  const deleteFileSpan = document.querySelector("span.tpo-delete__file");
  if (deleteFileSpan) {
    deleteFileSpan.click();
  }

  const mime = base64Data.match(/data:(.*);base64,/)[1];
  const blob = base64ToBlob(base64Data, mime);
  const file = new File([blob], "cropped-image.png", { type: mime });

  // Clear the file input first
  fileInput.value = "";
  fileInput.files = null;

  // Create new DataTransfer and add the file
  const dataTransfer = new DataTransfer();
  dataTransfer.items.add(file);
  fileInput.files = dataTransfer.files;

  // Dispatch events to notify of the change
  fileInput.dispatchEvent(new Event("change", { bubbles: true }));
  fileInput.dispatchEvent(new Event("input", { bubbles: true }));
  // fileInput.click();
};

class WallpaperCustomizer {
  constructor() {
    this.freeDeliveryThreshold = window.freeDeliveryThreshold;
    this.previewImage = document.getElementById("wallpaper-preview");
    this.cropper = null;
    this.easifyLoaded = false;
    this.syncInProgress = false;
    this.imageNaturalWidth = 0;
    this.imageNaturalHeight = 0;
    this.option_set = {};
    this.option_meta = {};
    this.elements = {};
    this.init();
    this.scaleX = 1;
    this.scaleY = 1;
    this.productData = {};
    this.storageData = {};
  }

  init() {
    // Check if all required elements are loaded
    let checkDom = setInterval(() => {
      this.option_set = window.TPOConfigs.product_options_easify.find((o) => o.option_set.title === window.productConfigKey).option_set;
      const optionSetAvailable = Object.keys(this.option_set).length > 0;

      this.elements = {
        inputElements: document.querySelectorAll(".wallpaper-customizer .easify-product-options input"),
        buttonElements: document.querySelectorAll(".wallpaper-customizer .easify-product-options button"),
        sourcePriceEl: document.querySelector(".t4s-product-price.tpo_product_price"),
        totalPriceEl: document.querySelector("span#total-price"),
        // pricePerSqmEl: document.querySelector("#price-per-sqm"),
        typeInputEl: document.querySelector('[name="properties[Kies behangsoort]"]'),
      };
      const allElementsPresent = Object.values(this.elements).every((value) => value !== null);

      if (allElementsPresent && optionSetAvailable) {
        this.storageData = JSON.parse(localStorage.getItem("wallpaper-design")) || {};
        this.productData = window.productData;
        this.clientW = this.previewImage.clientWidth;
        this.clientH = this.previewImage.clientHeight;
        this.waitForEasifyContent();
        clearInterval(checkDom);
        // console.log("this.storageData", this.storageData);
      }
    }, 250);
  }

  waitForEasifyContent() {
    const easifyContainer = document.querySelector(".easify-product-options");
    const dimensionX = document.querySelector('input[data-tpo-dimension="x"]');
    // console.log("[easifyContainer]", easifyContainer);
    // console.log("[dimensionX]", dimensionX);
    if (easifyContainer && dimensionX) {
      this.easifyLoaded = true;
      this.setupCustomizer();
    } else {
      setTimeout(this.waitForEasifyContent, 100);
    }
  }

  updatePrice() {
    console.log("updatePrice running");
    const { sourcePriceEl, totalPriceEl } = this.elements;
    // console.log("[sourcePriceEl]", sourcePriceEl, totalPriceEl);
    if (sourcePriceEl && totalPriceEl) {
      const price = sourcePriceEl.textContent.trim();
      totalPriceEl.textContent = price;
    } else {
      setTimeout(this.updatePrice, 100);
    }
  }

  setupCustomizer() {
    this.setMetaData();
    this.initializeCropper();
    this.bindEvents();
    this.loadFromLocalStorage();
    this.addHelpText();
  }

  setMetaData() {
    const easifyFields = this.getEasifyFields();
    const selectedType = easifyFields.material.value;
    const currentIndex = this.option_set.options[0].option_types.findIndex((opt) => opt.label === selectedType);

    this.option_meta = JSON.parse(this.option_set.options[currentIndex + 1].metadata);

    const { maxX, maxY } = this.option_meta;
    this.scaleX = maxX / this.clientW;
    this.scaleY = maxY / this.clientH;
    // console.log("[metaData]", this.scaleX, this.scaleY);
  }

  getEasifyFields() {
    return {
      material: this.elements.typeInputEl,
      width: document.querySelector('input[data-tpo-dimension="x"]:not(:disabled)'),
      height: document.querySelector('input[data-tpo-dimension="y"]:not(:disabled)'),
    };
  }

  getValidValue(value, minVal, maxVal) {
    return Math.max(minVal, Math.min(Number.isNaN(value) ? minVal : value ?? minVal, maxVal));
  }

  initializeCropper() {
    if (this.cropper) {
      this.cropper.destroy();
    }
    const { minX: minWidth, maxX: maxWidth, minY: minHeight, maxY: maxHeight } = this.option_meta;
    const easifyFields = this.getEasifyFields();

    const widthCm = this.getValidValue(easifyFields.width.value, minWidth, maxWidth);
    const heightCm = this.getValidValue(easifyFields.height.value, minHeight, maxHeight);

    const aspectRatio = widthCm / heightCm;
    // console.log("[🍎]", easifyFields.width.value, easifyFields.height.value);

    const widthRatio = Math.max(0, Math.min((widthCm - minWidth) / (maxWidth - minWidth), 1));
    const heightRatio = Math.max(0, Math.min((heightCm - minHeight) / (maxHeight - minHeight), 1));
    const cropAreaRatio = Math.max(widthRatio, heightRatio);
    const autoCropArea = 0.6 + cropAreaRatio * 0.4;
    const forceFullCoverage = widthCm >= maxWidth && heightCm >= maxHeight;

    // console.table({ widthCm, heightCm, maxWidth, maxHeight, aspectRatio, autoCropArea, forceFullCoverage });

    this.cropper = new Cropper(this.previewImage, {
      // aspectRatio: aspectRatio,
      initialAspectRatio: aspectRatio,
      viewMode: 0,
      dragMode: "move",
      autoCropArea: forceFullCoverage ? 1 : autoCropArea,
      restore: false,
      guides: true,
      center: true,
      highlight: false,
      cropBoxMovable: true,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
      zoomOnWheel: false,
      movable: false,
      responsive: true,
      ready: () => {
        const imageData = this.cropper.getImageData();
        this.imageNaturalWidth = imageData.naturalWidth;
        this.imageNaturalHeight = imageData.naturalHeight;
        if (forceFullCoverage) {
          this.setCropToFullImage();
        }
        this.updateCropInfo();

        // Disable dragging on the canvas (image) but allow crop box movement
        const canvas = this.cropper.getCroppedCanvas();
        const container = this.previewImage.parentElement;
        const cropperCanvas = container.querySelector(".cropper-canvas");
        if (cropperCanvas) {
          cropperCanvas.style.pointerEvents = "none";
        }
        setTimeout(() => {
          this.updatePrice();
        }, 500);
      },
      cropend: () => {
        this.updateCropInfo();
      },
    });
  }

  updateCropper(data, i) {
    const currentCropData = this.cropper.getCropBoxData();
    // console.log("🔴 data", i, data);
    let updatedCropData = { ...currentCropData, ...data };
    setTimeout(() => {
      this.cropper.setCropBoxData(updatedCropData);
    }, 500);
  }

  // New method to set crop to cover full image
  setCropToFullImage() {
    if (!this.cropper) return;

    const canvasData = this.cropper.getCanvasData();

    this.cropper.setCropBoxData({
      left: canvasData.left,
      top: canvasData.top,
      width: canvasData.width,
      height: canvasData.height,
    });
  }

  bindEvents() {
    document.addEventListener("change", (e) => {
      // ("🟢🟢 change", e.target);
      if (e.target.hasAttribute("data-tpo-dimension")) {
        setTimeout(() => {
          this.handleDimensionChange();
        }, 50);
      }
      if (e.target === this.elements.typeInputEl) {
        setTimeout(() => {
          this.handleMaterialChange();
        }, 50);
      }
    });

    document.addEventListener("input", (e) => {
      // console.log("🟢🟢 input", e.target);
      if(e.isEasify) {
        this.updatePrice();
        return
      }
      if (e.target.hasAttribute("data-tpo-dimension")) {
        setTimeout(() => {
          this.handleDimensionChange();
        }, 50);
      }
    });

    // Listen for button clicks in easify-product-options that might change dimensions
    const typeSelection = document.querySelectorAll(".tpo_option-type-selection");

  typeSelection.forEach((btn) => {
    btn.addEventListener("click", () => {
       setTimeout(() => {
          this.handleDimensionChange();
        }, 100);
    });
  });

    document.addEventListener("click", (e) => {
      // console.log("🟢🟢 click", e.target);
      if (e.target.closest(".wallpaper-customizer .easify-product-options button")) {
        setTimeout(() => {
          this.handleDimensionChange();
        }, 100);
      }

      // Listen for material dropdown button clicks
      if (e.target.classList.contains("tpo_option-type-selection")) {
        setTimeout(() => {
          this.handleMaterialChange();
        }, 100);
      }
    });

    document.addEventListener("mutation", (e) => {
      // console.log("🟢🟢 mutation");
      const easifyFields = this.getEasifyFields();
      const selectedType = easifyFields.material.value;
      if (selectedType !== this.currentType) {
        this.currentType = easifyFields.material.value;
        this.setMetaData();
        this.handleDimensionChange();
        this.addHelpText();
      }
    });

    // Action buttons
    const addToCartBtn = document.getElementById("add-to-cart-btn");
    const downloadBtn = document.getElementById("download-crop-btn");
    const deleteFileBtn = document.querySelector(".tpo-file__img .tpo-file__preview .tpo-delete__file");

    if (deleteFileBtn) {
      deleteFileBtn.addEventListener("click", () => {
        console.log("Delete file button clicked");
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
        }
      });
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.addEventListener("click", () => {
        this.addToCart();
      });
    }

    // Handle download button click
    if (downloadBtn) {
      downloadBtn.addEventListener("click", () => {
        this.downloadCrop();

        setTimeout(() => {
          if (addToCartBtn) {
            addToCartBtn.disabled = false;
          }
        }, 2000);
      });
    }
  }

  handleMaterialChange() {
    // console.log("Material changed");
    this.saveToLocalStorage();
  }

  handleDimensionChange() {
    console.log("handleDimensionChange running 1");
    if (this.skipCropperReinit || this.isSyncing) {
      console.log("Skipping handleDimensionChange");
      return;
    }

    const { minX: minWidth, maxX: maxWidth, minY: minHeight, maxY: maxHeight } = this.option_meta;
    const easifyFields = this.getEasifyFields();
    this.syncInputs(easifyFields.width.value, easifyFields.height.value);

    const widthCm = this.getValidValue(easifyFields.width.value, minWidth, maxWidth);
    const heightCm = this.getValidValue(easifyFields.height.value, minHeight, maxHeight);

    // this.initializeCropper();
    const data = {
      width: widthCm / this.scaleX,
      height: heightCm / this.scaleY,
    };

    this.updateCropper(data, "1");
    setTimeout(() => {
      this.updateCropInfo();
    }, 100);
    this.updatePrice();
    this.saveToLocalStorage();

     setTimeout(() => {
      const input = easifyFields.width;
      const event = new Event("input", { bubbles: true });
      event.isEasify = true;
      input.dispatchEvent(event);
    }, 0);
  }

  updateCropInfo() {
    if (!this.cropper) return;

    const cropData = this.cropper.getData(); // this gives the actual crop rectangle relative to natural image
    const { minX: minWidth, maxX: maxWidth, minY: minHeight, maxY: maxHeight } = this.option_meta;
    const easifyFields = this.getEasifyFields();

    // Get dimensions in cm
    const widthCm = this.getValidValue(easifyFields.width.value, minWidth, maxWidth);
    const heightCm = this.getValidValue(easifyFields.height.value, minHeight, maxHeight);

    // Display pixel positions and size in the natural image
    const cropPositionEl = document.getElementById("crop-position");
    const cropSizeEl = document.getElementById("crop-size");

    if (cropPositionEl) {
      cropPositionEl.textContent = `X: ${Math.round(cropData.x)}px, Y: ${Math.round(cropData.y)}px`;
    }
    if (cropSizeEl) {
      cropSizeEl.textContent = `${Math.round(cropData.width)} × ${Math.round(cropData.height)} px (${widthCm} × ${heightCm} cm)`;
    }

    // Calculate and update total area
    this.updateTotalArea(widthCm, heightCm);
  }

  updateTotalArea(widthCm, heightCm) {
    const widthM = widthCm / 100;
    const heightM = heightCm / 100;
    const totalAreaM2 = widthM * heightM;

    const totalAreaEl = document.getElementById("total-area");
    if (totalAreaEl) {
      totalAreaEl.textContent = `${totalAreaM2.toFixed(2)} m²`;
    }
  }

  addToCart() {
    this.skipCropperReinit = true;
    const errorElements = document.querySelectorAll(".tpo_error-message.tpo_undefined");
    let hasError = false;

    errorElements.forEach((el) => {
      if (el.textContent.trim() !== "") {
        hasError = true;
      }
    });

    if (hasError) {
      return;
    }

    const canvas = this.cropper.getCroppedCanvas({
      width: 800,
      height: 600,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    });

    canvas.toBlob(
      (blob) => {
        const file = new File([blob], "wallpaper-crop.jpg", {
          type: "image/jpeg",
        });

        // Create a Blob URL for preview in console
        const blobUrl = URL.createObjectURL(blob);

        // Locate your file input
        const fileInput = document.querySelector(
          'div.tpo_option-container.tpo_flex-100 .tpo_file-upload input.tpo_option-input[type="file"]'
        );

        // Create DataTransfer and set the file
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInput.files = dataTransfer.files;

        // Confirm in console
        fileInput.dispatchEvent(new Event("change", { bubbles: true }));
      },
      "image/jpeg",
      0.9
    );

    // Add crop data to the Easify form
    this.addCropDataToEasifyForm();

    // trigger submit button clicked
    const addToCartButton = document.querySelector(".main_add_cart .t4s-product-form__submit");
    if (addToCartButton) {
      addToCartButton.click();
    }
    document.querySelector(".t4s-form__product").submit();

    setTimeout(() => {
      this.skipCropperReinit = false;
    }, 1000);
  }

  addCropDataToEasifyForm() {
    const form = document.querySelector('form[action*="cart/add"]');
    if (!form) return;

    const easifyFields = this.getEasifyFields();
    const widthCm = parseFloat(easifyFields.width?.value) || 0;
    const heightCm = parseFloat(easifyFields.height?.value) || 0;

    // Add crop data as hidden inputs
    const cropPositionText = document.getElementById("crop-position")?.textContent || "";
    const cropSizeText = document.getElementById("crop-size")?.textContent || "";
    const pixelDimensions = cropSizeText.split(" (")[0] || cropSizeText;

    const cropData = {
      'Crop X': cropPositionText.split(',')[0]?.replace('X: ', '') || '0px',
      'Crop Y': cropPositionText.split(',')[1]?.replace(' Y: ', '') || '0px',
      // 'Dimensions CM': cropSizeText,
      // 'Dimensions CM': pixelDimensions,
      "Total Area": document.getElementById("total-area")?.textContent || "",
      "Total Price": document.getElementById("total-price")?.textContent || "",
    };

    Object.keys(cropData).forEach((key) => {
      // Remove existing crop data inputs
      const existing = form.querySelector(`input[name="properties[${key}]"]`);
      if (existing) {
        existing.remove();
      }
      // Add new crop data input
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${key}]`;
      input.value = cropData[key];
      form.appendChild(input);
    });
  }

  downloadCrop() {
    this.skipCropperReinit = true;
    if (!this.cropper) {
      alert("No crop area selected");
      return;
    }

    const canvas = this.cropper.getCroppedCanvas({
      width: 800,
      height: 600,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    });

    const isIOS = () => {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
      // Detect iPadOS 13+ (which reports as Mac)
      const iPadOS13Plus = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
      return iOS || iPadOS13Plus;
    };
  
  canvas.toBlob(
    (blob) => {
      if (!blob) {
        alert("Image processing failed.");
        return;
      }
  
      if (isIOS()) {
        // iOS: Use blob URL and open in new tab
        const blobUrl = URL.createObjectURL(blob);
        const newTab = window.open();
        if (newTab) {
          newTab.document.body.innerHTML = `<img src="${blobUrl}" style="width:100%">`;
        } else {
          alert("Please allow popups to preview the image.");
        }
      } else {
        // Non-iOS: Trigger download
        const link = document.createElement("a");
        link.download = "wallpaper-crop.jpg";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }
    },
    "image/jpeg",
    0.9
  );


    // canvas.toBlob(
    //   (blob) => {
    //     const link = document.createElement("a");
    //     link.download = "wallpaper-crop.jpg";
    //     link.href = URL.createObjectURL(blob);
    //     link.click();
    //     URL.revokeObjectURL(link.href);
    //   },
    //   "image/jpeg",
    //   0.9
    // );

    let croppedImageUrl = canvas.toDataURL("image/jpeg", 0.8);

    const fileInput = document.querySelector('div.tpo_option-container.tpo_flex-100 .tpo_file-upload input.tpo_option-input[type="file"]');
    setFileInputFromBase64(croppedImageUrl, fileInput);

    setTimeout(() => {
      this.skipCropperReinit = false;
    }, 500);
  }

  saveToLocalStorage() {
    if (!this.easifyLoaded) return;

    const easifyFields = this.getEasifyFields();
    const currentCropData = this.cropper.getCropBoxData();
    const { top, left } = currentCropData;

    const { handle } = this.productData;
    this.storageData[handle] = {
      width: easifyFields.width?.value || "",
      height: easifyFields.height?.value || "",
      material: easifyFields.material?.value || "",
      top,
      left,
      ts: new Date().getTime(),
    };
    localStorage.setItem("wallpaper-design", JSON.stringify(this.storageData));
  }

  addHelpText() {
    // console.log("🪵 addHelpText running");
    const { minX, maxX, suffixX, minY, maxY, suffixY } = this.option_meta;

    const dimensionXX = document.querySelectorAll('input[data-tpo-dimension="x"]');
    const dimensionYY = document.querySelectorAll('input[data-tpo-dimension="y"]');

    dimensionXX.forEach((input) => {
      const label = input.closest("label.tpo_dimension_label");
      const div = input.closest("div");

      if (label && div && !label.querySelector(".limit_for_x")) {
        const spanX = document.createElement("span");
        spanX.className = "limit_for_x";
        spanX.textContent = `(${minX}${suffixX} - ${maxX}${suffixX})`;
        label.insertBefore(spanX, div.nextSibling);
      }
    });

    dimensionYY.forEach((input) => {
      const label = input.closest("label.tpo_dimension_label");
      const div = input.closest("div");

      if (label && div && !label.querySelector(".limit_for_y")) {
        const spanY = document.createElement("span");
        spanY.className = "limit_for_y";
        spanY.textContent = `(${minY}${suffixY} - ${maxY}${suffixY})`;
        label.insertBefore(spanY, div.nextSibling);
      }
    });
  }

  loadFromLocalStorage() {
    try {
      if (!this.storageData || !this.storageData[this.productData.handle]) return;
      const storageData = this.storageData[this.productData.handle];

      const currentTime = new Date().getTime();
      const diffInHours = (currentTime - storageData.ts) / (1000 * 60 * 60);
      // console.log("[storageData]", storageData);
      if (diffInHours > 2) return;

      const easifyFields = this.getEasifyFields();
      const { minX: minWidth, maxX: maxWidth, minY: minHeight, maxY: maxHeight } = this.option_meta;

      // console.log("[data 3]", easifyFields);

      if (storageData.material && easifyFields.material) {
        // Find and click the appropriate material button
        const materialButtons = document.querySelectorAll(".tpo_option-type-selection");
        materialButtons.forEach((button) => {
          const label = button.querySelector(".tpo_option_type_label");
          if (label && label.textContent.trim() === storageData.material) {
            button.click();

            // Set the hidden input value
            easifyFields.material.value = storageData.material;
            this.currentType = storageData.material;
          }
        });
      }

      this.syncInputs(storageData.width, storageData.height);

      // this.syncDisabledInputs(storageData.width, storageData.height);

      const widthCm = this.getValidValue(storageData.width, minWidth, maxWidth);
      const heightCm = this.getValidValue(storageData.height, minHeight, maxHeight);

      // console.log("sizedata", widthCm, heightCm);

      const data = {
        width: widthCm / this.scaleX,
        height: heightCm / this.scaleY,
        top: storageData.top,
        left: storageData.left,
      };

      this.updateCropper(data, "2");
      setTimeout(() => {
        this.updatePrice();
      }, 1500);
    } catch (e) {
      console.error("Error loading saved design:", e);
    }
  }

  syncInputs(x, y) {
    this.isSyncing = true;
    const xInputs = document.querySelectorAll('input[data-tpo-dimension="x"]');
    const yInputs = document.querySelectorAll('input[data-tpo-dimension="y"]');
    xInputs.forEach((input) => {
      input.value = x;
    });

    yInputs.forEach((input) => {
      input.value = y;
    });
    this.isSyncing = false;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  new WallpaperCustomizer();
});
